import GetMindToolsDialog from './dialog'
import ShareDialogPanel from './share-dialog-panel'

export { ShareDialogPanel }

export default GetMindToolsDialog
